import commonMessages from 'lang/es/common'
import AppraisalFormApp from 'apps/AppraisalForm'
import appraisalMessages from 'lang/es/appraisal'
import { getCommonStaticProps } from 'commonPage'
import {
  simplifiedStatusBar, allowedFormatToUploadImage, whatsappEasyLanding,
} from 'vars'
import { safePromise } from 'utils/universal/safePromise'
import get from 'lodash/get'
import { sellYourCarMapper, modalsMapper } from 'mappers/sycMapper'
import axios from 'axios'

export default AppraisalFormApp

export async function getStaticProps(context) {
  const commonStaticProps = await getCommonStaticProps()
  const { params } = context
  const url = `${process.env.NEXT_PUBLIC_API_WORDPRESS}/acf/v3/options/syc-flow`
  const { result } = await safePromise(axios(url))
  const tabs = get(result, 'data.acf.tabs', [])
  const tabsEasy = get(result, 'data.acf.tabs_easy', [])
  const modals = get(result, 'data.acf.modals', [])

  const messages = {
    ...commonMessages,
    ...appraisalMessages,
  }

  return {
    props: {
      hideFooter: true,
      hideMenu: true,
      params,
      simplifiedStatusBar,
      headerProps: {
        isAppraisalForm: true,
        whatsappMessage: {
          id: 'VTA_WHATSAPP_MESSAGE',
        },
        variantWhatsappPhone: 'clikauto',
      },
      tabs: sellYourCarMapper(tabs),
      tabsEasy: sellYourCarMapper(tabsEasy),
      modals: modalsMapper(modals),
      messages,
      allowedFormatToUploadImage,
      whatsappEasyLanding,
      ...commonStaticProps,
    },
  }
}

export async function getStaticPaths() {
  const APPRAISAL_ROUTES = [
    commonMessages.ROUTE_QUOTE_CAR_STEP_YEAR,
    commonMessages.ROUTE_QUOTE_CAR_STEP_MAKE,
    commonMessages.ROUTE_QUOTE_CAR_STEP_MODEL,
    commonMessages.ROUTE_QUOTE_CAR_STEP_VERSION,
    commonMessages.ROUTE_QUOTE_CAR_STEP_COLOR,
    commonMessages.ROUTE_QUOTE_CAR_STEP_KILOMETERS,
    commonMessages.ROUTE_QUOTE_CAR_STEP_INFORMATION,
    commonMessages.ROUTE_QUOTE_CAR_STEP_OFFERS_DIRECT_SALLING,
    commonMessages.ROUTE_QUOTE_CAR_STEP_OFFERS_DIRECT_SALLING_EASY,
    commonMessages.ROUTE_QUOTE_CAR_STEP_OFFERS_EASY,
    commonMessages.ROUTE_QUOTE_CAR_STEP_SCHEDULE_INSPECTION_VARIANT,
    commonMessages.ROUTE_QUOTE_CAR_STEP_SCHEDULE_INSPECTION_EASY_VARIANT,
    commonMessages.ROUTE_QUOTE_CAR_STEP_SCHEDULE_CONFIRMATION,
    commonMessages.ROUTE_QUOTE_CAR_STEP_SCHEDULE_CONFIRMATION_DIRECT,
    commonMessages.ROUTE_QUOTE_CAR_STEP_SCHEDULE_EXPEDIENTE_CONFIRMATION,
    commonMessages.ROUTE_QUOTE_CAR_STEP_SCHEDULE_EXPEDIENTE,
  ]

  const paths = APPRAISAL_ROUTES.map((step) => ({ params: { step } }))

  return {
    paths,
    fallback: true,
  }
}
